// extracted by mini-css-extract-plugin
module.exports = {"card":"EducationTile_card__2slc2","card_inner":"EducationTile_card_inner__kpsK1","card_front":"EducationTile_card_front__i5gNm","card_back":"EducationTile_card_back__1e7X_"};